import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderAgeCategoriesStore implements SaveStateHolder {
  @observable
  readonly ageCategoryIds: number[];
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly languageId: number,
              ageCategoryIds: number[]) {
    makeObservable(this);
    this.ageCategoryIds = ageCategoryIds.slice();
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.ageCategoryIds, index1, index2);
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    const reordered = this.ageCategoryIds.slice();
    this.save = contentLoaders.x1language.orderChildren(this.languageId, reordered);
  }
}
